import { Navigate, Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import { useAuthStore } from "@mobile/stores";
import { LoadingOverlay } from "@mobile/components/ui/loading";

export function ProtectedRoute() {
  const { user, status, init } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (status === "idle") {
      void init();
    }
  }, [init, status]);

  if (status === "loading") {
    return <LoadingOverlay />;
  }

  if (status === "success" && !user) {
    return <Navigate to="/login" />;
  }

  if (user && !user.isProfileComplete && location.pathname !== "/welcome") {
    return <Navigate to="/welcome" />;
  }

  if (user && user.isProfileComplete && location.pathname === "/welcome") {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
